/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Cash_OutflowInputs */

const vi_dashboard_manager_cash_outflow = /** @type {(inputs: Dashboard_Manager_Cash_OutflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền ra`)
};

/**

* @param {Dashboard_Manager_Cash_OutflowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_cash_outflow = /** @type {((inputs?: Dashboard_Manager_Cash_OutflowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Cash_OutflowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_cash_outflow(inputs)
});